import React from 'react';
import { Route, Switch } from 'react-router-dom';
import PropTypes from 'prop-types';

import {
  TICKETS_ROUTE,
  TICKET_DETAIL_MOBILE_ROUTE,
  REQUEST_NOT_PRODUCT_TICKET,
  REQUEST_BILL_IMAGE,
  REQUEST_BLOCK_CARD,
  REQUEST_CHANGE_RIPLEYCARD,
  REQUEST_PAY_ACCOUNT,
  REQUEST_RPGO_INFORMATION,
  REQUEST_INSURANCES_INFORMATION,
  REPORT_PAGE_ERROR,
  REPORT_PURCHASE_ERROR,
  REQUEST_EXTEND_GIFT_CARD,
  REQUEST_EXTEND_GIFT_CARD_COMPANY,
  REPORT_GIFTCARD_PROBLEM,
  GENERAL_CLUBS_PROBLEMS,
} from '../../../constants/Routes';

import TarjetaRipleyIcon from '../../common/icons/ic_TarjetaRipley.svg';
import PurchasesRipleyComIcon from '../../common/icons/ic_PurchasesRipleyCom.svg';
import GiftCardsIcon from '../../common/icons/ic_GiftCard.svg';
import ClubsIcon from '../../common/icons/rclubes.svg';

import MyTickets from './MyTickets';
import TicketDetailView from './mobile/detail-view/TicketDetailView';
import MakeRequest from './solicitudes-atencion/Components/MakeRequest';
import MobileIssueBody from './solicitudes-atencion/mobile/MobileIssueBody';
import BallotInvoiceCopy from './solicitudes-atencion/Components/BallotInvoiceCopy';
import {
  caseBlockCard,
  caseChangeRipleyCard,
  caseExtendCompanyGiftCard,
  caseInsurancesRipley,
  casePayAccount,
  caseRipleyPtosGo,
} from './solicitudes-atencion/Messages';
import { useMakeRequestStyles } from './solicitudes-atencion/styles';
import OnlyMessageBody from './solicitudes-atencion/mobile/OnlyMessageBody';
import FormErrorInPage from './solicitudes-atencion/Components/FormErrorInPage';
import ExtendGiftCard from './solicitudes-atencion/Components/ExtendGiftCard';
import GiftCardProblem from './solicitudes-atencion/Components/GiftCardProblem';
import ClubsGeneralProblems from './solicitudes-atencion/Components/ClubsGeneralProblems';

const TicketRoutes = ({ ...props }) => {
  const { mobile } = props;
  const classes = useMakeRequestStyles();

  return (
    <Switch>
      <div className={classes.container}>
        <Route exact path={TICKETS_ROUTE}>
          <MyTickets mobile={mobile} path={TICKETS_ROUTE} />
        </Route>
        <Route exact path={TICKET_DETAIL_MOBILE_ROUTE}>
          <TicketDetailView />
        </Route>
        <Route exact path={REQUEST_NOT_PRODUCT_TICKET}>
          <MakeRequest mobile={mobile} />
        </Route>
        <Route exact path={REQUEST_BLOCK_CARD}>
          <MobileIssueBody
            icon={TarjetaRipleyIcon}
            title="Tarjeta Ripley"
            subtitle="Bloqueo de Tarteja Ripley"
          >
            <OnlyMessageBody mobile message={caseBlockCard(mobile)} />
          </MobileIssueBody>
        </Route>
        <Route exact path={REQUEST_CHANGE_RIPLEYCARD}>
          <MobileIssueBody
            icon={TarjetaRipleyIcon}
            title="Tarjeta Ripley"
            subtitle="Consulta Tarjeta Ripley"
          >
            <OnlyMessageBody mobile message={caseChangeRipleyCard(mobile)} />
          </MobileIssueBody>
        </Route>
        <Route exact path={REQUEST_PAY_ACCOUNT}>
          <MobileIssueBody
            icon={TarjetaRipleyIcon}
            title="Tarjeta Ripley"
            subtitle="Pago de estado de cuenta"
          >
            <OnlyMessageBody mobile message={casePayAccount} />
          </MobileIssueBody>
        </Route>
        <Route exact path={REQUEST_RPGO_INFORMATION}>
          <MobileIssueBody
            icon={TarjetaRipleyIcon}
            title="Tarjeta Ripley"
            subtitle="Ripley Puntos Go"
          >
            <OnlyMessageBody mobile message={caseRipleyPtosGo(mobile)} />
          </MobileIssueBody>
        </Route>
        <Route exact path={REQUEST_INSURANCES_INFORMATION}>
          <MobileIssueBody
            icon={TarjetaRipleyIcon}
            title="Tarjeta Ripley"
            subtitle="Seguros Ripley"
          >
            <OnlyMessageBody mobile message={caseInsurancesRipley(mobile)} />
          </MobileIssueBody>
        </Route>
        <Route exact path={REQUEST_BILL_IMAGE}>
          <MobileIssueBody
            icon={PurchasesRipleyComIcon}
            title="Compras en Ripley.com"
            subtitle="Copia boleta/factura"
          >
            <BallotInvoiceCopy mobile />
          </MobileIssueBody>
        </Route>
        <Route exact path={REPORT_PAGE_ERROR}>
          <MobileIssueBody
            icon={PurchasesRipleyComIcon}
            title="Compras en Ripley.com"
            subtitle="Error en la página"
          >
            <FormErrorInPage
              mobile
              motiveId={33}
              type={7}
              title="Descripción del error"
              idComplement="ErrorPage"
            />
          </MobileIssueBody>
        </Route>
        <Route exact path={REPORT_PURCHASE_ERROR}>
          <MobileIssueBody
            icon={PurchasesRipleyComIcon}
            title="Compras en Ripley.com"
            subtitle="Inconveniente al momento de comprar"
          >
            <FormErrorInPage
              mobile
              motiveId={17}
              type={7}
              title="Descripción del inconveniente"
              idComplement="PurchaseError"
            />
          </MobileIssueBody>
        </Route>
        <Route exact path={REQUEST_EXTEND_GIFT_CARD}>
          <MobileIssueBody
            icon={GiftCardsIcon}
            title="Gift Cards"
            subtitle="Extender vigencia Gift Card"
          >
            <ExtendGiftCard mobile type={9} motiveId={31} />
          </MobileIssueBody>
        </Route>
        <Route exact path={REQUEST_EXTEND_GIFT_CARD_COMPANY}>
          <MobileIssueBody
            icon={GiftCardsIcon}
            title="Gift Cards"
            type={9}
            motiveId={31}
            subtitle="Extender vigencia Gift Card Empresa"
          >
            <OnlyMessageBody mobile message={caseExtendCompanyGiftCard} />
          </MobileIssueBody>
        </Route>
        <Route exact path={REPORT_GIFTCARD_PROBLEM}>
          <MobileIssueBody
            icon={GiftCardsIcon}
            title="Gift Cards"
            type={9}
            motiveId={36}
            subtitle="Inconveniente con mi Gift Card"
          >
            <GiftCardProblem mobile type={9} motiveId={36} />
          </MobileIssueBody>
        </Route>
        <Route exact path={GENERAL_CLUBS_PROBLEMS}>
          <MobileIssueBody
            icon={ClubsIcon}
            title="Clubes Ripley"
            type={9}
            motiveId={'general-clubs'}
            subtitle="Solicitudes frecuentes"
          >
            <ClubsGeneralProblems mobile type={11} />
          </MobileIssueBody>
        </Route>
      </div>
    </Switch>
  );
};

TicketRoutes.propTypes = {
  mobile: PropTypes.bool,
};

export default TicketRoutes;
